import { Action, StateContext, State, Store, Selector } from '@ngxs/store';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { NotificationService } from '../../../../../../common/services';
import { AllocationViewFinishDepartureSecurityModel } from '../../models';
import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  AllocationViewFinishDepartureSecurityAction,
  AllocationViewFinishDepartureSecurityActionPrepare,
  AllocationViewFinishDepartureSecurityActionSetInitialState,
} from './allocation-view-finish-departure-security-action.actions';
import { AllocationViewFinishDepartureSecurityActionService } from './allocation-view-finish-departure-security-action.service';
import { AllocationViewActionBaseState } from '../base';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';

export interface AllocationViewFinishDepartureSecurityActionStateModel {
  loaded: boolean;
  preparedDetails: AllocationViewFinishDepartureSecurityModel;
}

const initialState: AllocationViewFinishDepartureSecurityActionStateModel = {
  loaded: false,
  preparedDetails: null,
};

@State({
  name: 'allocationViewActionsFinishDepartureSecurity',
  defaults: initialState,
})
@Injectable()
export class AllocationViewFinishDepartureSecurityActionState extends AllocationViewActionBaseState {
  @Selector()
  static getLoaded(state: AllocationViewFinishDepartureSecurityActionStateModel): boolean {
    return state.loaded;
  }

  @Selector()
  static getPreparedDetails(
    state: AllocationViewFinishDepartureSecurityActionStateModel,
  ): AllocationViewFinishDepartureSecurityModel {
    return state.preparedDetails;
  }

  constructor(
    private allocationViewFinishDepartureSecurityActionService: AllocationViewFinishDepartureSecurityActionService,
    notificationService: NotificationService,
    store: Store,
  ) {
    super(notificationService, store);
  }

  @Action(AllocationViewFinishDepartureSecurityAction)
  departureSecurityFinish(
    ctx: StateContext<AllocationViewFinishDepartureSecurityActionStateModel>,
    { data }: AllocationViewFinishDepartureSecurityAction,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.allocationViewFinishDepartureSecurityActionService.departureSecurityFinish(data).pipe(
      tap(() => {
        this.finishAction('api.uli.success.finishDepartureSecurity');
      }),
      catchError(({ error }: HttpErrorResponse) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(AllocationViewFinishDepartureSecurityActionPrepare)
  departureSecurityFinishPrepare(
    ctx: StateContext<AllocationViewFinishDepartureSecurityActionStateModel>,
    { identifier, language }: AllocationViewFinishDepartureSecurityActionPrepare,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | AllocationViewFinishDepartureSecurityModel> {
    return this.allocationViewFinishDepartureSecurityActionService
      .departureSecurityFinishPrepare(identifier, language)
      .pipe(
        tap((response: AllocationViewFinishDepartureSecurityModel) => {
          ctx.patchState({
            preparedDetails: response,
            loaded: true,
          });
        }),
        catchError(({ error }: HttpErrorResponse) => of(this.notificationService.error(error.message))),
      );
  }

  @Action(AllocationViewFinishDepartureSecurityActionSetInitialState)
  setInitialState(ctx: StateContext<AllocationViewFinishDepartureSecurityActionStateModel>): void {
    ctx.setState(initialState);
    this.setContainerAfterActionEffectsInitialState();
  }
}
